import { toast } from "react-toastify";
import { api } from "../../services/api";


const consultaListaLeadTime = async (token, page = 1) => {
    try {
        const { data } = await api.get(
            `/tiposPedido/?page=${page}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
        );

        const tiposPedidoFormatados = data.map((tp) => ({
            value: tp.tipoPedido,
            label: tp.descricao,
        }));

        return tiposPedidoFormatados;

    } catch (err) {
        console.error("ops! ocorreu um erro : ", err);

        toast.error(
            err?.response?.data
                ? JSON.stringify(err.response.data)
                : "Erro ao buscar tipos de pedido"
        );

        return [];
    }
};

export { consultaListaLeadTime };